import {Component, Input} from '@angular/core';
import {IconType, IoniconsOutline, ND} from '@pt/pt-models';
import {DocResourceStatus} from "it/primatoo/openapi/api/org/schemas/common/DocResourceStatus";

@Component({
  selector: 'pt-treatment-action-state',
  template: `
    <ng-container [ngSwitch]='status'>
      <ng-container *ngSwitchCase='DocResourceStatus.DRAFT'>
        <!--        <ng-container *ngIf='completed < 100'>-->
        <!--          <span [ngbTooltip]='noCompletedMessage'>-->
        <!--            <button class='btn btn-sm btn-success d-flex align-items-center'-->
        <!--                    [disabled]='disablePublish' (click)='publicAction.emit()'-->
        <!--                    [ngClass]='[disablePublish ? "cursor-not-allowed" : "", cssClass]'>-->
        <!--                <pt-icon [iconType]='IconType.IONIC_ICON' [key]='IconPublish' [size]='14'></pt-icon>-->
        <!--                <span class='font-11'>{{'BUTTON.PUBLIC' | translate}}</span>-->
        <!--            </button>-->
        <!--          </span>-->
        <!--        </ng-container>-->

        <!--        <ng-container *ngIf='completed === 100'>-->
        <!--          <button class='btn btn-sm btn-success d-flex align-items-center'-->
        <!--                  [disabled]='disablePublish' (click)='publicAction.emit()'-->
        <!--                  [ngClass]='[disablePublish ? "cursor-not-allowed" : "", cssClass]'>-->
        <!--            <pt-icon [iconType]='IconType.IONIC_ICON' [key]='IconPublish' [size]='14'></pt-icon>-->
        <!--            <span class='font-11'>{{'BUTTON.PUBLIC' | translate}}</span>-->
        <!--          </button>-->
        <!--        </ng-container>-->

        <!--        <div style="display: flex; width: 110px;">-->
        <!--          <button class='btn btn-sm btn-success d-flex'-->
        <!--                  style='width: 140px'-->
        <!--                  [disabled]='disablePublish'-->
        <!--                  (click)='publicAction.emit()'>-->
        <!--            <pt-icon [iconType]='IconType.IONIC_ICON' [key]='IconPublish' [size]='14'></pt-icon>-->
        <!--            <span style='margin-top: 1px;'-->
        <!--                  [ngbTooltip]='completed < 100 ? noCompletedMessage: ""'-->
        <!--                  placement="left-bottom"-->
        <!--                  class="font-11">{{'BUTTON.PUBLIC' | translate}}</span>-->
        <!--          </button>-->

        <!--          <div class='btn-group btn-group-sm' ngbDropdown role='group'>-->
        <!--            <button ngbDropdownToggle-->
        <!--                    class='btn btn-sm btn-success dropdown-toggle-split'>-->
        <!--            </button>-->
        <!--            <div class='dropdown-menu' ngbDropdownMenu>-->
        <!--              <button [disabled]='disableDelete'-->
        <!--                      ngbDropdownItem-->
        <!--                      type='button' class='btn-sm cursor-pointer'-->
        <!--                      (click)='deleteAction.emit()'>-->
        <!--                <span class="font-11">{{'LABELS.DELETE' | translate}}</span>-->
        <!--              </button>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--        </div>-->

      </ng-container>

      <ng-container *ngSwitchCase='DocResourceStatus.PUBLISHED'>
        <!--        <button class='btn btn-sm btn-success d-flex align-items-center'-->
        <!--                [disabled]='disableReopen' (click)='reopenAction.emit()'-->
        <!--                [ngClass]='[disableReopen ? "cursor-not-allowed" : "", cssClass]'>-->
        <!--          <pt-icon [iconType]='IconType.IONIC_ICON' [key]='IconReopen' [size]='14'></pt-icon>-->
        <!--          <span class='font-11'>{{'BUTTON.REOPEN' | translate}}</span>-->
        <!--        </button>-->
      </ng-container>

      <div *ngSwitchDefault>{{ ND }} {{ status }}</div>
    </ng-container>
  `
})
export class TreatmentActionStateComponent {

  @Input() cssClass = '';
  @Input() completed?: number;
  @Input() status?: DocResourceStatus;
  // @Input() disableReopen: boolean;
  // @Input() disablePublish: boolean;
  // @Input() disableDelete: boolean;

  @Input() noCompletedMessage = '';
  // @Output() deleteAction = new EventEmitter();
  // @Output() publicAction = new EventEmitter();
  // @Output() reopenAction = new EventEmitter();

  public ND = ND;
  public DocResourceStatus = DocResourceStatus;
  public IconPublish = IoniconsOutline.globe;
  public IconDelete = IoniconsOutline.trash;

  public IconReopen = IoniconsOutline.edit;
  public IconType = IconType;
}
